import moment from 'moment';

export default ({
	EN: {
		title: usingClick => usingClick ? 'Review Appointment' : 'Review Request',
		instructions: usingClick => usingClick ?
			'Last, please review your appointment details below.' :
			'Last, please review your request details below.',
		formatDate: date => moment.utc(new Date(date)).format('dddd, MMM DD, YYYY'),
		inspectorComment: 'Add a note for inspector (optional)',
		confirmAppointment: usingClick => usingClick ? 'Confirm appointment' : 'Send request',
		pageTitle: 'Review'
	},
	ES: {
		title: usingClick => usingClick ? 'Revisar la cita' : 'Solicitud de revisión',
		instructions: usingClick => usingClick ?
			'Por favor, revele los detalles de su cita abajo.' :
			'Por último, revise los detalles de su solicitud a continuación',
		formatDate: date => moment.utc(new Date(date)).format('dddd, MMM DD, YYYY'),
		inspectorComment: 'Agregar una nota para el inspector (opcional)',
		confirmAppointment: usingClick => usingClick ? 'Confirmar cita' : 'Envviar petición',
		pageTitle: 'Revisión'
	}
});
